var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiSrMinusSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.9995C6.73478 10.9995 6.48043 11.1049 6.29289 11.2924C6.10536 11.4799 6 11.7343 6 11.9995C6 12.2647 6.10536 12.5191 6.29289 12.7066C6.48043 12.8942 6.73478 12.9995 7 12.9995H17C17.2652 12.9995 17.5196 12.8942 17.7071 12.7066C17.8946 12.5191 18 12.2647 18 11.9995C18 11.7343 17.8946 11.4799 17.7071 11.2924C17.5196 11.1049 17.2652 10.9995 17 10.9995H7Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiSrMinusSmall);
export default __webpack_public_path__ + "static/media/fi-sr-minus-small.f8226b089a848540a7f4e5b237c1dfce.svg";
export { ForwardRef as ReactComponent };